import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setTravelLengthValue } from 'state/advertsFilters/actions';
import filterAdverts from 'state/adverts/operations/filterAdverts';
import FilterByTravelLengthComponent from './FilterByTravelLengthComponent';

class FilterByTravelLength extends Component {
  constructor(props) {
    super(props);

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(value) {
    const { setTravelLengthValue, filterAdverts } = this.props;
    setTravelLengthValue(value);
    filterAdverts();
  }

  render() {
    const { travelLength, colors } = this.props;
    const { options, value } = travelLength;

    return (
      <FilterByTravelLengthComponent
        colors={colors}
        options={options}
        selectedOptions={value}
        onChange={this.handleOnChange}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    travelLength: state.advertsFilters.travelLength,
    colors: state.theme.colors,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setTravelLengthValue(value) {
      dispatch(setTravelLengthValue(value));
    },
    filterAdverts() {
      dispatch(filterAdverts());
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FilterByTravelLength);
